
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.75 5c0-.69.56-1.25 1.25-1.25h2a1.25 1.25 0 110 2.5h-2c-.69 0-1.25-.56-1.25-1.25zm-1.396-.75a2.751 2.751 0 012.646-2h2c1.259 0 2.32.846 2.646 2H17A2.75 2.75 0 0119.75 7v12A2.75 2.75 0 0117 21.75H7A2.75 2.75 0 014.25 19V7A2.75 2.75 0 017 4.25h1.354zm7.293 1.5H17A1.25 1.25 0 0118.25 7v12A1.25 1.25 0 0117 20.25H7A1.25 1.25 0 015.75 19V7A1.25 1.25 0 017 5.75h1.354a2.751 2.751 0 002.646 2h2c1.259 0 2.32-.846 2.646-2zM7.25 12a.75.75 0 01.75-.75h.01a.75.75 0 010 1.5H8a.75.75 0 01-.75-.75zm3.75-.75a.75.75 0 000 1.5h5a.75.75 0 000-1.5h-5zM7.25 16a.75.75 0 01.75-.75h.01a.75.75 0 010 1.5H8a.75.75 0 01-.75-.75zm3.75-.75a.75.75 0 000 1.5h5a.75.75 0 000-1.5h-5z"}})])
          )
        }
      }
    